export enum GuideTypes {
  CHANGE_INFORMATION = '@showInformation/CHANGE_INFORMATION',
}

export interface IShowInformation {
  showInformation: boolean
}
